import { FormattedMessage } from 'react-intl'
import {KTSVG} from '../../../../../../_metronic/helpers'
import {useListView} from '../../core/ListViewProvider'
import {PaymentsListFilter} from './PaymentsListFilter'

const PaymentsListToolbar = () => {
  const {setItemIdForUpdate} = useListView()
  const openAddPaymentModal = () => {
    setItemIdForUpdate(null)
  }

  return (
    <div className='d-flex justify-content-end' data-kt-payment-table-toolbar='base'>
      <PaymentsListFilter />

      {/* begin::Export */}
      <button type='button' className='btn btn-light-primary me-3'>
        <KTSVG path='/media/icons/duotune/arrows/arr078.svg' className='svg-icon-2' />
        <FormattedMessage id='TABLE.GENERAL.EXPORT' />      </button>
      {/* end::Export */}

      {/* begin::Add payment */}
      <button type='button' className='btn btn-primary' onClick={openAddPaymentModal}>
        <KTSVG path='/media/icons/duotune/arrows/arr075.svg' className='svg-icon-2' />
        <FormattedMessage id='PAYMENT.TABLE.CREATEPAYMENT' defaultMessage={"Add Payment"} />
      </button>
      {/* end::Add payment */}
    </div>
  )
}

export {PaymentsListToolbar}
